import { SxProps, Theme } from "@mui/material";

export const customerTypeSelectorStyles = {
    button: {
        width: "100%",
        padding: 0,
        margin: 0,
    },
    rateContainer: (isSelected: boolean): SxProps<Theme> => ({
        marginTop: 1,
        borderRadius: 1,
        width: "100%",
        backgroundColor: isSelected ? "#d5cdcd" : "#fff",
    }),
    rowContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
    },
    leftSection: (
        isSelected: boolean,
        capacity: number
    ): SxProps<Theme> => ({
        flex: capacity === 1 ? "1" : "0.8",
        borderRight: 2,
        borderColor: isSelected ? "#d5cdcd" : "#fff",
    }),
    leftSectionContent: {
        padding: "10px 8px",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
    },
    leftSectionTextContainer: {
        width: "100%",
        textAlign: "left",
    },
    customerTypeTitle: {
        fontSize: 15,
        fontWeight: 800,
        marginBottom: "-3px",
    },
    availabilityText: {
        fontSize: 13,
    },
    priceText: {
        fontSize: 17,
        fontWeight: 800,
    },
    rightSection: {
        flex: "0.2",
    },
    selectStyle: {
        backgroundColor: "white",
        border: "none",
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
        },
        ".css-11bgdin-MuiSelect-icon": {
            top: "unset",
        },
    },
};
